module.exports = "/static/fonts/OpenSans-Regular.ttf";